'use client'

import { useCallback } from 'react'

import { getQueryClient, QueryKey } from 'shared/api'
import toast from 'shared/ui/utils/toast'
import { getApiErrors } from 'shared/utils/errors'

import { useCustomerData } from '../hooks/useCustomerData'

import CustomerConsentSwitch from './CustomerConsentSwitch'

import styles from './MarketingConsents.module.scss'

const MarketingConsents = () => {
  const { update, updatedUser: user } = useCustomerData()

  const handleNewsletterConsentChange = useCallback(
    async (value: boolean) => {
      try {
        await update({ isNewsletterSubscriber: value })
        await getQueryClient().refetchQueries({
          queryKey: [QueryKey.rebateCodes]
        })
      } catch (err) {
        console.error(err)
        toast.error(getApiErrors(err))
      }
    },
    [update]
  )

  const handleSMSConsentChange = useCallback(
    async (value: boolean) => {
      try {
        await update({ smsConsentsGranted: value })
      } catch (err) {
        console.error(err)
        toast.error(getApiErrors(err))
      }
    },
    [update]
  )

  return (
    <div className={styles.wrapper} id='profile_marketing_consent'>
      <CustomerConsentSwitch
        checked={!!user?.isNewsletterSubscriber}
        onConsentChange={handleNewsletterConsentChange}
        label='Zgoda na komunikację marketingową poprzez newsletter'
        switchId='newsletter-consent-switch'
        modalId='newsletter-consent-modal'
        modalTitle='Zgoda na newsletter'
        modalDescription='Czy na pewno chcesz przestać otrzymywać newsletter?'
        confirmTestId='newsletter-consent-confirm-button'
        cancelTestId='newsletter-consent-cancel-button'
      />
      <CustomerConsentSwitch
        checked={!!user?.smsConsentsGranted}
        onConsentChange={handleSMSConsentChange}
        label='Zgoda na komunikację marketingową poprzez SMS'
        switchId='sms-consent-switch'
        modalId='sms-consent-modal'
        modalTitle='Zgoda na SMS'
        modalDescription='Czy na pewno chcesz wycofać zgody na komunikację SMS?'
        confirmTestId='sms-consent-confirm-button'
        cancelTestId='sms-consent-cancel-button'
      />
    </div>
  )
}

export default MarketingConsents
